import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, LinearProgress, TextField } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useNavigate, useParams } from "react-router-dom";

// NewUser page components
import FormField from "components/FormField";
import axios from "axios";
import { URL_API } from "config";
import { toast } from "react-toastify";
import MDButton from "components/MDButton";
import { useAuthContext } from "context/AuthContext";

const payload = {
  gender: 2,
  document_type: 1,
  document_number: "",
  issuing_body: "",
  document_uf: "",
  issue_date: "",
  nationality: "",
  birth_city: "",
  birth_uf: "",
  mothers_name: "",
  fathers_name: ""
}

export default function CooperatedInfoThird() {
  const [cooperated, setCooperated] = useState(payload);

  const [inputValueGender, setInputValueGender] = useState('');
  const [gender, setGender] = useState(2);

  const [inputValueDoc, setInputValueDoc] = useState('');
  const [docType, setDocType] = useState(1);

  const [loading, setLoading] = useState(false);

  const optionsGender = ["Masculino", "Feminino"];
  const optionsDocument = ["RG", "CNH", "Passaporte", "CTPS", "CDI", "RNE"];

  const { uuid } = useParams();
  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (uuid) {
          setLoading(true)

          const response = await axios.get(`${URL_API}/cooperated/${uuid}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          setGender(response.data.gender);
          setDocType(response.data.document_type);

          setCooperated(response.data);

          setLoading(false)
        }
      } catch (e) {
        toast.error(e.response.data)
      }
    })()
    // eslint-disable-next-line
  }, [uuid])

  const genderText = (val) => {
    switch (val) {
      case 1:
        return "Masculino";
      case 2:
        return "Feminino";
      default:
        return val;
    }
  }

  const genderNumber = (val) => {
    switch (val) {
      case "Masculino":
        return 1;
      case "Feminino":
        return 2;
      default:
        return val;
    }
  }

  const document = (doc) => {
    switch (doc) {
      case 1:
        return "RG";
      case 2:
        return "CNH";
      case 3:
        return "Passaporte";
      case 4:
        return "CTPS";
      case 5:
        return "CDI";
      case 6:
        return "RNE";
      default:
        return doc;
    }
  }

  const documentNumber = (doc) => {
    switch (doc) {
      case "RG":
        return 1;
      case "CNH":
        return 2;
      case "Passaporte":
        return 3;
      case "CTPS":
        return 4;
      case "CDI":
        return 5;
      case "RNE":
        return 6;
      default:
        return doc;
    }
  }

  const setInput = (event) => {
    const { name, value } = event.target;

    const newCooperated = {
      ...cooperated,
      [name]: value,
    };

    setCooperated(newCooperated);
  };

  const handleNext = async () => {
    try {
      if (user.profile !== 99) {
        const data = {
          ...cooperated,
          gender: genderNumber(gender),
          document_type: documentNumber(docType),
          step: 3
        }

        if (
          // !data.birth_date ||
          !data.gender ||
          !data.document_type ||
          !data.document_number ||
          !data.issuing_body ||
          !data.document_uf ||
          !data.issue_date ||
          !data.nationality ||
          !data.birth_city ||
          !data.birth_uf ||
          !data.mothers_name
        ) return toast.warn("Preecha os dados obrigatórios");

        if (uuid) {
          const response = await axios.put(`${URL_API}/cooperated/${uuid}`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${uuid}?step=4`);
        } else {
          const response = await axios.post(`${URL_API}/cooperated`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${response.data.uuid}?step=4`);
        }
      } else {
        navigate(`/admin/colaboradores/atualizar/${uuid}?step=3`);
      }
    } catch (e) {
      toast.error(e.response.data)
    }
  }

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Sobre</MDTypography>
        <MDTypography variant="button" color="text">
          Informações obrigatórias *
        </MDTypography>
      </MDBox>

      {
        loading ?
          <Box sx={{ width: '100%' }}>
            <LinearProgress sx={{ overflow: 'hidden' }} />
          </Box> :
          <>
            <MDBox mt={1.625}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={genderText(gender ?? cooperated.gender)}
                    onChange={(_, newValue) => {
                      setGender(newValue);
                    }}
                    inputValue={inputValueGender}
                    onInputChange={(_, newInputValue) => {
                      setInputValueGender(newInputValue);
                    }}
                    options={optionsGender}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" label="Sexo" required />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={document(docType ?? cooperated.document_type)}
                    onChange={(_, newValue) => {
                      setDocType(newValue);
                    }}
                    inputValue={inputValueDoc}
                    onInputChange={(_, newInputValue) => {
                      setInputValueDoc(newInputValue);
                    }}
                    options={optionsDocument}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Tipo do Documento"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Número do Documento"
                    name="document_number"
                    value={cooperated.document_number}
                    placeholder="Número do Documento"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Órgão Emissor"
                    name="issuing_body"
                    value={cooperated.issuing_body}
                    placeholder="Órgão Emissor"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="UF"
                    name="document_uf"
                    value={cooperated.document_uf}
                    placeholder="UF"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Data de Emissão"
                    name="issue_date"
                    value={cooperated.issue_date}
                    mask="date"
                    placeholder="Data de Emissão"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Nacionalidade"
                    name="nationality"
                    value={cooperated.nationality}
                    placeholder="Nacionalidade"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Cidade de Nascimento"
                    name="birth_city"
                    value={cooperated.birth_city}
                    placeholder="Cidade de Nascimento"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="UF de Nascimento"
                    name="birth_uf"
                    value={cooperated.birth_uf}
                    placeholder="UF de Nascimento"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Nome da Mãe"
                    name="mothers_name"
                    value={cooperated.mothers_name}
                    placeholder="Nome da Mãe"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Nome do Pai"
                    name="fathers_name"
                    value={cooperated.fathers_name}
                    placeholder="Nome do Pai"
                    onChange={setInput}
                  />
                </Grid>
              </Grid>
            </MDBox>

            <MDBox
              mt={2}
              width="100%"
              display="flex"
              justifyContent="space-between"
            >
              <MDButton
                variant="gradient"
                color="light"
                onClick={() => {
                  if (user.profile !== 99) {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=2`)
                  } else {
                    navigate(`/admin/colaboradores/atualizar/${uuid}?step=1`)
                  }
                }}
              >
                voltar
              </MDButton>
              <MDButton
                type="submit"
                variant="gradient"
                color="dark"
                onClick={handleNext}
              >
                próximo
              </MDButton>
            </MDBox>
          </>
      }
    </MDBox>
  );
}

// typechecking props for CooperatedInfoThird
CooperatedInfoThird.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
